import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.447 22.992a.916.916 0 0 1-1.023-.796c-.42-3.357-3.001-5.613-6.424-5.613s-6.004 2.256-6.424 5.614a.916.916 0 1 1-1.819-.227c.532-4.251 3.921-7.22 8.243-7.22s7.712 2.969 8.243 7.22a.916.916 0 0 1-.796 1.022M5.125 7.417c0-.506.41-.917.917-.917H6.5v-.458A5.047 5.047 0 0 1 11.542 1h.916A5.047 5.047 0 0 1 17.5 6.042V6.5h.458a.917.917 0 0 1 0 1.833H17.5c0 3.033-2.467 5.5-5.5 5.5a5.505 5.505 0 0 1-5.5-5.5h-.458a.917.917 0 0 1-.917-.916m10.542.916H8.333A3.67 3.67 0 0 0 12 12a3.67 3.67 0 0 0 3.667-3.667M8.333 6.5h7.334v-.458a3.21 3.21 0 0 0-2.75-3.176v1.8a.917.917 0 0 1-1.834 0v-1.8a3.21 3.21 0 0 0-2.75 3.176z"
    }, null, -1)
  ]))]))
}
export default { render: render }